// extracted by mini-css-extract-plugin
module.exports = {"D_section4":"Section4_D_section4__ieyXB"};